import React from 'react';

type FillColor = string;
type ClassName = string;

interface Props {
  fillColor?: FillColor;
  className?: ClassName;
}

const CirclePlus = ({
  fillColor = '#3C3C3C',
  className = '',
}: Props): React.ReactElement<React.ReactNode> => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="15"
    className={className}
    viewBox="0 0 15 15"
    fill="none"
    aria-hidden={true}
  >
    <g clipPath="url(#clip0)">
      <path
        d="M11.2441 8.55798H8.56975V8.57831V11.2323C8.56975 11.8223 8.08997 12.3021 7.5 12.3021C6.91003 12.3021 6.43025 11.8223 6.43025 11.2323V8.57831V8.55798H6.40993H3.75588C3.16592 8.55798 2.68614 8.0782 2.68614 7.48823C2.68614 6.89827 3.16592 6.41849 3.75588 6.41849H6.40993H6.43025V3.74412C6.43025 3.15415 6.91003 2.67437 7.5 2.67437C8.08997 2.67437 8.56975 3.15415 8.56975 3.74412V6.41849H11.2441C11.8341 6.41849 12.3139 6.89827 12.3139 7.48823C12.3139 8.0782 11.8341 8.55798 11.2441 8.55798ZM12.8038 2.19673C11.4463 0.839217 9.57103 0 7.5 0C5.42897 0 3.5537 0.839217 2.19673 2.19673C0.839217 3.55424 0 5.42897 0 7.5C0 9.57157 0.839217 11.4463 2.19673 12.8038C3.5537 14.1608 5.42897 15.0005 7.5 15.0005C9.57103 15.0005 11.4463 14.1608 12.8038 12.8038C14.1608 11.4463 15 9.57157 15 7.5C15 5.42897 14.1608 3.55424 12.8038 2.19673Z"
        fill={fillColor}
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="15" height="15" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export { CirclePlus };
